import React from 'react';
type Tome = {
  number: string;
  title: string;
  weeks: string;
  framework: string;
  promise: string;
  band: string;
  badge: string;
  contents: string[];
};
const tomes: Tome[] = [{
  number: '1',
  title: 'Start Safe',
  weeks: 'Weeks 1–9',
  framework: "The Media Control Dial · The Can't-Draw Reset",
  promise: 'First sessions, rapport and the client who says "I can\'t draw."',
  band: 'bg-sage',
  badge: 'bg-sage-soft text-sage-deep',
  contents: ['Week 1, Scribble Chase: a first session anyone can do', 'My Name, My Way: rapport without a single interview question', 'Pick the right material for each client in 30 seconds', 'Three moves that unfreeze a client who says "I can\'t draw"', 'A Safe-Enough Place: a contained, trauma-aware version', 'The client who finishes in 2 minutes or asks you to draw it']
}, {
  number: '2',
  title: 'Feel and Regulate',
  weeks: 'Weeks 10–18',
  framework: 'Name, Place, Shift · The 0-to-5 Feeling Scale',
  promise: 'Naming emotions and building calming skills through art.',
  band: 'bg-peach',
  badge: 'bg-peach-soft text-peach-deep',
  contents: ['A personal feelings color key the client reuses all year', 'Emotion Creatures: give a hard feeling a shape and a name', 'Where It Lives in Me, with an abstract default and a body option', "My Calm Card: a pocket card of the client's own tools", 'Worry, Checked and Stormy to Still', 'When a client floods, goes blank or laughs everything off']
}, {
  number: '3',
  title: 'Know Myself',
  weeks: 'Weeks 19–27',
  framework: 'The Strength Mirror · The Inner Voice Swap',
  promise: 'Identity, strengths and self-worth through art.',
  band: 'bg-rose',
  badge: 'bg-rose-soft text-rose-deep',
  contents: ['The Inside/Outside Envelope: what others see, what stays inside', 'Strength Stones, with the evidence behind each one', 'A four-panel comic of a time the client coped', 'The Critic, Drawn: change its size and its voice', 'Why "that\'s beautiful" can shut identity work down', 'A self-portrait without a face']
}, {
  number: '4',
  title: 'Connect',
  weeks: 'Weeks 28–36',
  framework: 'The Closer, Farther, Protected Rule · Group Canvas Rules',
  promise: 'Relationships, boundaries and group work through art.',
  band: 'bg-lav',
  badge: 'bg-lav-soft text-lav-deep',
  contents: ['Circles of Closeness: who is near, who is far', 'My People in Symbols, without drawing faces', 'My Boundary Fence and Yes, No and Maybe Doors', 'Five agreements that make shared art safe for every member', 'Pass the Page and the Sectioned Mural, with one-to-one versions', "When members criticize, copy or ruin each other's art"]
}, {
  number: '5',
  title: 'Stress, Change and Loss',
  weeks: 'Weeks 37–44',
  framework: 'The Container First Rule · The Loss Lens',
  promise: 'Coping, transitions and grief work, with containment built in.',
  band: 'bg-sky',
  badge: 'bg-sky-soft text-sky-deep',
  contents: ['The Stress Backpack: what the client carries and could set down', "The Container Drawing, for what's too big to open today", 'Memory Box and Grief Waves, marked Deep for trained clinicians', 'A grounding protocol with a green, amber and red pacing check', 'A safeguarding and referral checklist', 'How to run a 6-week loss or change group']
}, {
  number: '6',
  title: 'Grow Forward',
  weeks: 'Weeks 45–52',
  framework: 'The Past, Present and Next Triptych · Keep, Return or Store',
  promise: 'Resilience, goals and closing your work together well.',
  band: 'bg-teal',
  badge: 'bg-teal-soft text-teal-deep',
  contents: ['Golden Repair: mend what broke with gold lines', 'Then and Now: redraw the theme the client arrived with', 'Future Self Portrait and Small Steps Across', 'My Mini Exhibition and The Goodbye Book', 'A timeline for the last four sessions', 'What to do with client artwork when your work ends']
}];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="paper-grain w-full bg-paper" data-id="element-325" data-mp="3lzrvj3dyl8s8">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20" data-id="element-326" data-mp="3h5no6j0s6yqm">
        <div className="text-center" data-id="element-327" data-mp="3uxkc0avf2mh7">
          <p className="text-sm font-semibold text-teal-deep" data-id="element-328" data-mp="3uwiqtdkosjlr">The complete year</p>
          <h2 id="tomes-heading" className="mt-3 font-display text-3xl font-semibold text-navy sm:text-5xl" data-id="element-329" data-mp="3pyh9ax2wssce">
            Six volumes. <span className="wash-text" data-id="element-330" data-mp="8p2m7m6kh5x0">Fifty-two sessions.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-navy-soft" data-id="element-331" data-mp="3sllztm3f13k">
            The volumes follow the arc of a year of work, from safety to
            closing well. Each one stands on its own, with its own kit,
            sessions, worksheets and field card, so you can start any volume
            with any client.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-332" data-mp="q07swo9c4qp8">
          {tomes.map(tome => <article key={tome.number} className="flex flex-col overflow-hidden rounded-3xl bg-white shadow-card" data-id="element-333" data-mp="bc37vdmt833a">
              <span className={`h-2 w-full ${tome.band}`} data-id="element-334" data-mp="g9mp8met0vzg" />
              <div className="flex flex-1 flex-col p-6" data-id="element-335" data-mp="2awrr5o2ouak">
                <div className="flex items-center gap-2.5" data-id="element-336" data-mp="29bxzi9l1fdr">
                  <span className={`flex h-9 w-9 items-center justify-center rounded-full font-display text-base font-semibold ${tome.badge}`} data-id="element-337" data-mp="6d06c361gf02">
                    {tome.number}
                  </span>
                  <span className="text-xs font-semibold text-navy-muted" data-id="element-338" data-mp="3tgenm59rvdlv">
                    Volume {tome.number}, {tome.weeks}
                  </span>
                </div>
                <h3 className="mt-3 font-display text-2xl font-semibold leading-snug text-navy" data-id="element-339" data-mp="1rptjr6k67vnh">{tome.title}</h3>
                <p className="mt-1 text-xs font-bold text-teal-deep" data-id="element-340" data-mp="1q97ak9wskx2h">{tome.framework}</p>
                <p className="mt-2 text-sm text-navy-soft" data-id="element-341" data-mp="1l9uovshnpw1h">{tome.promise}</p>
                <ul className="mt-4 grid gap-2 border-t border-paper-dark pt-4" data-id="element-342" data-mp="1lbxo934p91iv">
                  {tome.contents.map(item => <li key={item} className="flex gap-2 text-[13px] text-navy" data-id="element-343" data-mp="1bbwzh1o29t7a">
                      <span className={`mt-[7px] h-1.5 w-1.5 flex-none rounded-full ${tome.band}`} data-id="element-344" data-mp="28z5qfc6tzugo" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}